import { getUser } from "@/utils/localStorage";
import { isBitramp } from "@/utils/utils";
import React from "react";

const HeaderArea: React.FC = () => {
  const user = getUser();
  const fullName = `${user?.first_name} ${user?.last_name}`;
  return (
    <div className="w-full py-3 px-8">
      <div className="flex justify-between items-center w-full">
        <h1 className="Heading2 dark-blue bold">My Dashboard</h1>
        <div className="flex justify-center items-center flex-col">
          <div
            className={`flex justify-start items-center gap-2 ${
              isBitramp() ? "text-white" : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 35 35"
              fill="none"
            >
              <path
                d="M17.5 33.5C21.7857 33.5 25.6814 31.8129 28.5521 29.0683C31.599 26.1578 33.5 22.0498 33.5 17.5C33.5 8.66334 26.3367 1.5 17.5 1.5C8.66334 1.5 1.5 8.66334 1.5 17.5C1.5 22.0842 3.42971 26.2209 6.51865 29.1361C9.38132 31.8394 13.2157 33.5 17.5 33.5Z"
                stroke={`${isBitramp() ? "#fff" : "#222B45"}`}
                stroke-width="3"
              />
              <path
                d="M27.5158 27.9854C24.9131 30.4739 21.3846 32.0017 17.4998 32.0017C13.615 32.0017 10.1449 30.4992 7.54834 28.0472C7.59363 27.9235 7.63631 27.8051 7.6729 27.6927C8.81394 24.2347 12.4252 20.7985 17.4632 20.7794C22.4534 20.7619 26.1448 24.1363 27.3259 27.6936C27.3895 27.7633 27.4539 27.8626 27.5158 27.9854Z"
                fill={`${isBitramp() ? "#fff" : "#222B45"}`}
              />
              <path
                d="M17.4892 19.5812C16.0894 19.5638 14.8622 19.0925 13.8021 18.1936C12.5931 17.1684 11.8771 15.8523 11.5723 14.3054C11.4712 13.7923 11.4199 13.2732 11.439 12.7506C11.5043 10.9937 12.0871 9.4398 13.2943 8.14632C14.1087 7.27442 15.1008 6.67603 16.2715 6.42778C17.9456 6.07327 19.4934 6.39643 20.874 7.41814C22.2746 8.45466 23.0855 9.86399 23.4261 11.559C23.5402 12.1278 23.589 12.7035 23.5533 13.2819C23.4418 15.0893 22.7955 16.6676 21.4828 17.9384C20.6005 18.792 19.5492 19.3321 18.3245 19.5054C18.0475 19.5446 17.7662 19.5568 17.4874 19.5812H17.4892Z"
                fill={`${isBitramp() ? "#fff" : "#222B45"}`}
              />
            </svg>
            <span className="Text dark-blue bold">{fullName}</span>
          </div>
          <div className="flex justify-end gap-2 items-center w-full">
            <span className="Text dark-blue regular">verified</span>
            <input
              defaultChecked={true}
              className="checked:bg-[#49af49]"
              type="checkbox"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderArea;
